import { Link } from 'react-router-dom';
import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

// ###############################################################
// <----------------------- Doctors List ------------------------>
// ###############################################################
export const Wrapper = styled.div`
  flex-grow: 1;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const LoaderWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: left;
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-template: 1fr / 2fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr 1fr 3fr;
  column-gap: 16px;
  padding: 0 24px;
`;

export const Divider = styled.hr`
  width: calc(100% + 48px);
  grid-column: 1 / 11;
  margin: 0 -24px;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.grey003};
`;

export const Header = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 10px 0;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const ItemColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 68px;

  & > * + * {
    margin-top: 4px !important;
  }
`;

export const ItemRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 68px;

  & > * + * {
    margin-inline-start: 6px;
  }
`;

export const ItemWrapper = styled.div``;

export const ItemTextWrapper = styled.div`
  display: inline-block;
  padding: 1px 4px;
  border-radius: 4px;
  background-color: ${({ backgroundColor }) => backgroundColor || ''};
  border: 1px solid ${({ borderColor }) => borderColor || ''};
`;

export const ItemLink = styled(Link)`
  text-decoration: none;
`;

export const ItemText = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme, color }) => color || theme.colors.black};

  ${({ inline }) =>
    inline &&
    `
    display: inline-block
  `}
`;

export const ItemTextBold = styled(typography.BodyTextOneBoldTypography)`
  margin: 0;
  color: ${({ theme, color }) => color || theme.colors.black};

  ${({ inline }) =>
    inline &&
    `
    display: inline-block
  `}
`;

export const ItemSubText = styled(typography.BodyTextTwoRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const ItemClick = styled(ItemText)`
  cursor: pointer;
`;

export const ItemTag = styled(typography.BodyTextThreeRegularTypography)`
  margin: 0;
  padding: 2px 4px;
  width: fit-content;
  color: ${({ theme }) => theme.colors.primaryMain};
  background-color: ${({ theme }) => theme.colors.primaryLight};
  border-radius: 4px;
  text-align: center;

  ${({ margin }) =>
    margin &&
    `
    margin: 6px 6px 0 0 ;
  `}

  ${({ hover }) =>
    hover &&
    `
    cursor: pointer;
  `}
`;

export const ItemBtn = styled(typography.BodyTextTwoRegularTypography)`
  padding: 8px 12px;
  color: ${({ theme, color }) => color || theme.colors.white};
  background-color: ${({ theme, backgroundColor }) => backgroundColor || theme.colors.primaryMain};
  border: 1px solid ${({ theme, borderColor }) => borderColor || theme.colors.primaryMain};
  border-radius: 4px;
  cursor: pointer;
`;
// ###############################################################
// <--------------------- End Doctors List ---------------------->
// ###############################################################

// ###############################################################
// <------------------- Doctor Actions Popup -------------------->
// ###############################################################
export const ActionsPopupWrapper = styled.div`
  padding: 30px 0;
  min-width: 550px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
`;

export const ActionsPopupTitleWrapper = styled.div`
  text-align: center;
`;

export const ActionsPopupTitle = styled(typography.TitleTwoTypography)`
  margin: 0;
`;

export const ActionsPopupBtnWrapper = styled.div`
  display: flex;
  padding: 0 20px;

  & * + * {
    margin-inline-start: 15px !important;
  }
`;

export const ActionsPopupYesBtn = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 8px 0;
  width: 60px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.greenMain};
  border: 0;
  border-radius: 4px;
  cursor: pointer;
`;

export const ActionsPopupNoBtn = styled(ActionsPopupYesBtn)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redMain};
  background-color: ${({ theme }) => theme.colors.redLight};
`;
// ###############################################################
// <----------------- End Doctor Actions Popup ------------------>
// ###############################################################

// ###############################################################
// <-------------------- Doctor Badges Popup -------------------->
// ###############################################################
export const BadgesPopupWrapper = styled.div`
  padding: 30px 0;
  min-width: 550px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
`;

export const BadgesItemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
`;

export const BadgesText = styled(typography.TitleOneRegularTypography)`
  margin: 0;
`;

export const BadgesAssignBtn = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 6px 0;
  width: 50px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.primaryMain};
  border: 1px solid ${({ theme }) => theme.colors.primaryMain};
  border-radius: 4px;
  cursor: pointer;
`;

export const BadgesRevokeBtn = styled(BadgesAssignBtn)`
  color: ${({ theme }) => theme.colors.primaryMain};
  background-color: ${({ theme }) => theme.colors.white};
`;

export const BadgesLoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
// ###############################################################
// <----------------- End Doctor Badges Popup ------------------->
// ###############################################################
